// A workspace's tile (ui-core draws it: its icon, else its first letter on
// one of six grounds picked from the id).
import {
  fileUrl,
  groundClass,
  TileMark,
  useMeApp,
  workspaceGroundIndex,
  workspaceInitial,
} from "@trameria/ui-core";

export { TileMark, workspaceGroundIndex, workspaceInitial };

export function workspaceGround(id: string): string {
  return groundClass(workspaceGroundIndex(id));
}

export function WorkspaceTile({
  id,
  name,
  iconFileId,
  size = 36,
  current = false,
}: {
  id: string;
  name: string;
  iconFileId?: string | null;
  size?: number;
  /** The place shown now: a squarer tile. */
  current?: boolean;
}) {
  const { apiBase } = useMeApp();
  return (
    <TileMark
      initial={workspaceInitial(name)}
      ground={workspaceGroundIndex(id)}
      image={iconFileId ? fileUrl(apiBase, iconFileId) : null}
      size={size}
      current={current}
    />
  );
}
